import type { AgenticLogicRuleSettings } from "@intelligems/ig-types/dtos/agentic-logic/rules";

/**
 * The compared fields of a settings object, listed rather than walked.
 *
 * Compared field by field over the known keys rather than through a deep-equal
 * helper, so a future settings field fails the type check here instead of
 * silently going uncompared.
 */
const COMPARED_SETTINGS_KEYS = {
  maxItems: true,
  excludeOutOfStock: true,
  excludeItemsInCart: true,
  excludePdpProduct: true,
  onEmpty: true,
  // `satisfies` and not a cast: a settings field added later has to be named
  // here or this object stops satisfying the record and the build fails.
} satisfies Record<keyof AgenticLogicRuleSettings, true>;

/**
 * Whether two settings objects say the same thing. ONE identity rule for the
 * recommendation settings, shared by every reader that has to decide whether
 * they changed — the editor's dirty state and the unpublished-drift banner.
 */
export const sameRuleSettings = (
  a: AgenticLogicRuleSettings,
  b: AgenticLogicRuleSettings
): boolean =>
  (
    Object.keys(COMPARED_SETTINGS_KEYS) as (keyof AgenticLogicRuleSettings)[]
  ).every((key) => a[key] === b[key]);
